import { observer } from 'mobx-react-lite'
import { Text } from '@/components/Text'
import type { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'
import type { Question } from '@/features/jobs/questions/questions'

export interface ResponseValueContainerProps {
  editorVm: QuestionAnswerEditorViewModelBase<Question>
}

/**
 * Renders a question's answer as read-only text.
 */
export const ResponseValueContainer = observer(function ResponseValueContainer({
  editorVm,
}: ResponseValueContainerProps) {
  switch (editorVm.type) {
    case 'Text':
      return <Text text={editorVm.textAnswer} />
    case 'Breaker':
      return <>(breaker)</>
    case 'Unknown':
      return <>Unknown question type</>
    case 'Bool':
    case 'Select':
    case 'Numeric':
    case 'DateTime':
    case 'Documents':
      return <>{editorVm.textAnswer}</>
  }
})
